import { downloadUrlFile } from 'services/helper/fileDownload';

// pdf handler
export const checkIfPdf = (url) => {
  const arr = url.split(".");
  return arr[arr.length - 1] === "pdf";
};

//   button functions
export const handleDownload = (file, fileName) => {
  downloadUrlFile({
    url: file,
    fileName,
    successMessage: 'File downloaded.',
  });
};
export const handleView = (file) => {
  window.open(file);
};

// convert claim_report_type to mui icon
export const ReportIconConstructor = (type) => {
  switch (type) {
    case "Personal":
      return "person_rounded";
    case "Company":
      return "business";
  }
};
